<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'DetailsTab',
  props: [
    'companyId'
  ]
}
</script>